import React, { useEffect, useState } from 'react';
import { getDynamicColor, randomColor } from '../../../../helper/helper';

export const DynamicExecutionForm = ({ schema, schema_value, onSubmit }) => {
    const [formData, setFormData] = useState({});

    useEffect(() => {
        if (schema_value?.args) {
            setFormData(schema_value.args);
        }
    }, [schema_value]);

    const handleChange = (path, value) => {
        const keys = path.split('.');
        setFormData(prev => {
            const updated = structuredClone(prev);
            let current = updated;
            for (let i = 0; i < keys.length - 1; i++) {
                if (!(keys[i] in current)) current[keys[i]] = isNaN(+keys[i + 1]) ? {} : [];
                current = current[keys[i]];
            }
            current[keys.at(-1)] = value;
            return updated;
        });
    };

    const getValue = (path) => {
        return path.split('.').reduce((o, k) => (o || {})[k], formData);
    };

    const renderField = (key, fieldSchema, path = '') => {
        const fullPath = path ? `${path}.${key}` : key;
        const value = getValue(fullPath);

        switch (fieldSchema.type) {
            case 'string':
                return (
                    <div key={fullPath} className="d-flex flex-column gap-2 mb-4">
                        <label className="block mb-1 capitalize bold">{key}</label>
                        <textarea
                            className="w-full border rounded p-2"
                            value={value || ''}
                            rows={3}
                            onChange={(e) => handleChange(fullPath, e.target.value)}
                            placeholder={fieldSchema.description || ''}
                        />
                    </div>
                );

            case 'object':
                return (
                    <div key={fullPath} className="mb-4 p-3 border rounded d-flex flex-column gap-2 mb-4">
                        <h3 className="font-semibold capitalize mb-2">{key}</h3>
                        {Object.entries(fieldSchema.properties || {}).map(([subKey, subSchema]) =>
                            renderField(subKey, subSchema, fullPath)
                        )}
                    </div>
                );

            case 'array':
                return (
                    <div key={fullPath} className="mb-4 border rounded p-3 d-flex flex-column gap-2">
                        <label className="block font-semibold mb-2 capitalize">{key}</label>
                        {(value || []).map((item, index) => {
                            const bg = randomColor()
                            return (
                                <div key={index} className="border p-3 mb-2 bg-gray-50 relative rounded d-flex flex-column " style={{ backgroundColor: bg }}>
                                    {fieldSchema.items.type === 'object' ? (
                                        Object.entries(fieldSchema.items.properties || {}).map(([childKey, childSchema]) =>
                                            renderField(childKey, childSchema, `${fullPath}.${index}`)
                                        )
                                    ) : (
                                        <input
                                            className="w-full border p-2"
                                            value={item}
                                            onChange={(e) =>
                                                handleChange(`${fullPath}.${index}`, e.target.value)
                                            }
                                        />
                                    )}
                                    <button
                                        type="button"
                                        onClick={() => handleArrayRemove(fullPath, index)}
                                        className="bnt btn-danger absolute top-2 right-2 text-white"
                                    >
                                        Delete
                                    </button>
                                </div>
                            )
                        })}
                        {value?.length === 0 && (
                            <p className="text-sm text-gray-500 italic">No items available.</p>
                        )}
                    </div>
                );

            default:
                return null;
        }
    };

    const handleArrayRemove = (path, indexToRemove) => {
        handleChange(path, (getValue(path) || []).filter((_, i) => i !== indexToRemove));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit?.(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="d-flex flex-column gap-4 p-4 bg-white rounded shadow-md">
            {Object.entries(schema?.parameters?.properties || {}).map(([key, fieldSchema]) =>
                renderField(key, fieldSchema)
            )}
            <button type="submit" className="mt-6 btn1 w-100 font-weight-bold w-100 text-center">Submit</button>
        </form>
    );
};
